WiseMetering.Views.ShowNetmoreIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/netmore/show',
    title: () => i18next.t('modal.title.integrations.show'),

    edit: function() {
        new WiseMetering.Views.EditNetmoreIntegration({ model: this.model });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            indicatorKind: this.model.indicatorKind(),
            integrationIndicators: this.model.integrationIndicators(),
            site: this.model.site()
        };
    }
});
